import useAutoOrderAction from './useAutoOrderAction';

export default useAutoOrderAction;
